import firebase from '../../firebase/compat';

// Enige ingang naar de `logClientRecordOpen` Cloud Function.
//
// Waarom een Cloud Function en niet een Firestore-schrijfactie: de auditregel
// moet onvervalsbaar zijn. Actor, bron-IP en user-agent worden server-side
// bepaald; wat de browser meestuurt wordt genegeerd. De regel gaat naar een
// Cloud Logging-bucket met gelockte retentie — niet naar Firestore, want daar
// bestaat geen write-once (de admin SDK omzeilt de regels).
//
// De regio is verplicht expliciet: de standaardclient wijst naar us-central1 en
// vindt de functie niet, wat als CORS-fout binnenkomt.
// AI-CONTEXT: See docs/features/clientdossier-auditlog.md

/**
 * @typedef {object} RecordOpenPayload
 * @property {string} client - CompagnyID van de tenant waar het dossier onder valt
 * @property {string} recordType - 'persona' of 'household' (zie recordTypes.js)
 * @property {string} [recordId] - Het dossier-id; verplicht bij een inzage
 * @property {string} [event] - 'clientRecordOpened' (standaard) of 'clientRecordExported'
 * @property {number} [rowCount] - Aantal geëxporteerde rijen; verplicht bij een export
 */

/**
 * @param {RecordOpenPayload} payload - Wat er gelogd moet worden
 * @returns {Promise<{logged: true}>} Bevestiging van de Cloud Function
 */
const callLogRecordOpen = async (payload) => {
    const logFn = firebase.app().functions('europe-west1').httpsCallable('logClientRecordOpen');
    const { data } = await logFn(payload);
    return data;
};

export default callLogRecordOpen;
